export default __webpack_public_path__ + "static/uppy-bg-overlay-7bc067e331559f8381e4fbc753c842c1.jpg";